module.exports = __webpack_public_path__ + "static/media/healthcare.2af6dd49.svg";